var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pull-auto top-menu"},[_c('el-menu',{attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"}},[_vm._l((_vm.items),function(item,index){return [_c('el-menu-item',{key:index,attrs:{"index":item.parentId+''},nativeOn:{"click":function($event){return _vm.openMenu(item)}}},[_vm._v(_vm._s(item.label))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }